import axios from 'axios'
import { gengetURLTEST, genURL } from "../../_getjson";

export default async function CheckCodeDocGroup(code, tablename, search) {
    console.log(search);
    if (code) {
        let rs = "";

        let Url = "CSDOCGROUP/Code?tablename=" + tablename + "&code=" + code + "&Usercode=" + localStorage.getItem("Username") + "&top=300"

        console.log("reCheckCodeDocGroup", genURL(Url))
        await axios.get(genURL(Url), { timeout: 5000 }).then((res) => {
            if (res.data.length === 1) {
                rs = res.data[0].MYNAMETH
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs
    }
};